import React from 'react';
import { Pressable, Text } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import useTranslation from '../../../hooks/translation-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import { useProfileCompletionBonus } from '../../../hooks/useProfileCompletionBonus';
import useMyAccountActions from '../../../hooks/myAccountActions-hook';
import NavigationElements from '../../../models/NavigationElements';

export default function ProfileBonusLink() {
  const { hasOffer, summary } = useProfileCompletionBonus();
  const t = useTranslation();
  const theme = useCustomTheme();
  const navigation = useNavigation();
  const actions = useMyAccountActions();
  if (!hasOffer) return null;
  return <Pressable accessibilityRole="button" testID="profile-bonus-menu-link" onPress={() => {
    actions.setProps({ profileBonusFocus: Date.now() });
    navigation.navigate(NavigationElements.myProfile as never);
  }} style={({ pressed }) => ({ minHeight: 44, paddingHorizontal: 16, paddingVertical: 12, justifyContent: 'center',
    backgroundColor: pressed ? (theme.isDark ? '#244C54' : '#DBEBE8') : 'transparent' })}>
    <Text style={{ color: theme.isDark ? '#DCF4ED' : '#035164', fontSize: 14, lineHeight: 20, textDecorationLine: 'underline', fontWeight: '600' }}>{t('profile-bonus-menu', { points: summary?.rewardPoints })}</Text>
  </Pressable>;
}
